/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tolerance_BandsInputs */

const en_nav_tolerance_bands = /** @type {(inputs: Nav_Tolerance_BandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery tolerances`)
};

/**
* | output |
* | --- |
* | "Delivery tolerances" |
*
* @param {Nav_Tolerance_BandsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_tolerance_bands = /** @type {((inputs?: Nav_Tolerance_BandsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tolerance_BandsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_tolerance_bands(inputs)
});